import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CHAPTERS_COMPONENT } from "../../core";

import { BookingEventComponent } from "./booking-event.component";

@NgModule({
    declarations: [BookingEventComponent],
    imports: [CommonModule],
    providers: [
        { provide: CHAPTERS_COMPONENT, useValue: BookingEventComponent },
    ],
})
export class BookingEventModule {}
